
import { Component, Mixins } from "vue-property-decorator";
import { IDrawableItem, PrintBehavior } from "../../../../../domain/document/items";
import { IDrawableItemEditable } from "../../IDrawableItemEditable";

@Component({
})
export default class DrawerPropertyEditableMixin extends Mixins() implements IDrawableItemEditable {
  editingSource: IDrawableItem;
  writeProperty: (write: (source: IDrawableItem) => void) => void;

  get printBehavior(): PrintBehavior {
    return this.editingSource
      ? this.editingSource.printBehavior
      : undefined;
  }

  set printBehavior(value: PrintBehavior) {
    this.writeProperty(s => s.printBehavior = value);
  }
}
